export class ProfileStatus {
  public constructor() {
    this.ID = 0;
    this.MemberType1 = '';
    this.MemberTypeDescr = '';
    this.DateChanged = new Date();
    this.DateCreated = new Date();
  }

  public ID: number;
  public MemberType1: string;
  public MemberTypeDescr: string;
  public DateCreated: Date;
  public DateChanged: Date;
}
